import styled from 'styled-components';
import { ReactComponent as RawMetricsSVG } from '../../../../assets/icons/icon_metrics.svg';

export const IconMetrics = styled(RawMetricsSVG)``;
